<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="E-Wallet Transaction " name="first">
                <Transaction></Transaction>
            </el-tab-pane>

            <el-tab-pane label="E-Wallet Top Up " name="3">
                <top-up></top-up>
            </el-tab-pane>

            <el-tab-pane label="E-Wallet Withdraw " name="second">
                <WithDraw></WithDraw>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Transaction from "@/view/eazable/wallet/Transactions";
    import WithDraw from "@/view/eazable/wallet/WithDraw";
    import TopUp from "./TopUp";

    export default {
        name: "WalletIndex",
        components: {TopUp, WithDraw, Transaction},
        data: () => {
            return {
                activeName: "first"
            }
        }
    }
</script>

<style scoped>

</style>
